import { Navigate, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { HomeLoading } from "@/components/home-loading";
import useAddShopMemberWithToken from "@babackapp/private-api-client/client/use-add-shop-member-with-token";
import { useEffect } from "react";
import { useAuth } from "@babackapp/auth-client/hooks";

function constructSearchString(token: string | null, email: string | null) {
  const urlSearchParams = new URLSearchParams();
  !token || urlSearchParams.append("token", token);
  !email || urlSearchParams.append("email", email);
  return urlSearchParams.toString();
}

export default function AutologinPage() {
  const auth = useAuth();
  const navigate = useNavigate();
  const { mutate: addShopMember } = useAddShopMemberWithToken({
    onSuccess: (_, variables) => {
      navigate(`/shops/${variables.shopId}`, { replace: true });
    },
  });
  const token = new URLSearchParams(window.location.search).get(
    "token",
  ) as string;
  const emailFromUrl = new URLSearchParams(window.location.search).get(
    "email",
  ) as string;

  useEffect(() => {
    if (auth.isLoading) return;
    if (!token) return;
    const { shopId } = jwtDecode(token as string) as {
      shopId: string;
    };

    if (auth.isAuthenticated && auth.user?.id) {
      addShopMember({
        shopId,
        data: { token, userId: auth.user.id },
      });
    }
  }, [token, auth.isLoading]);

  if (auth.isLoading) return <HomeLoading />;

  if (!auth.isAuthenticated)
    return (
      <Navigate
        to={`/auth/sign-up?${constructSearchString(token, emailFromUrl)}`}
        replace
      />
    );

  return <HomeLoading />;
}
